import { Settings } from "lucide-react";
import React, { useEffect, useState } from "react";
import { SettingsModal } from "./SettingsModal";

export const FilterButton = ({
	showDrafts,
	showBotPRs,
	onToggleDrafts,
	onToggleBotPRs,
	sortOption,
	onSetSortOption,
	showPendingWithProjectRules,
	onTogglePendingWithProjectRules,
	showPendingWithAllApprovals,
	onTogglePendingWithAllApprovals,
	greyOutBlockingComments,
	onToggleGreyOutBlockingComments,
	enableCommentsExpansion,
	onToggleCommentsExpansion,
	viewMode,
	onSetViewMode,
	showSwimlaneMergedColumn,
	onToggleShowSwimlaneMergedColumn,
	showSwimlaneDeletedColumn,
	onToggleShowSwimlaneDeletedColumn,
	useLocalTime,
	onToggleUseLocalTime,
	watchProjects,
	setWatchProjects,
	excludeProjects,
	setExcludeProjects,
	swimlaneHideCreatedDaysThreshold,
	setSwimlaneHideCreatedDaysThreshold,
	swimlaneHideUpdatedDaysThreshold,
	setSwimlaneHideUpdatedDaysThreshold,
}) => {
	const [settingsModalOpen, setSettingsModalOpen] = useState(false);

	// Handle Escape key to close modal
	useEffect(() => {
		const handleEscapeKey = (e) => {
			if (e.key === "Escape" && settingsModalOpen) {
				setSettingsModalOpen(false);
			}
		};

		document.addEventListener("keydown", handleEscapeKey);
		return () => document.removeEventListener("keydown", handleEscapeKey);
	}, [settingsModalOpen]);

	return (
		<>
			<button
				type="button"
				onClick={() => setSettingsModalOpen(true)}
				className="relative flex items-center justify-center rounded-md p-1 text-[var(--color-text-primary)] transition-colors hover:bg-[var(--color-bg-secondary)] focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)] focus:ring-opacity-50"
				aria-label="Open settings"
			>
				<Settings className="w-4 h-4" strokeWidth={2} />
			</button>

			{settingsModalOpen && (
				<SettingsModal
					isOpen={settingsModalOpen}
					onClose={() => setSettingsModalOpen(false)}
					showDrafts={showDrafts}
					showBotPRs={showBotPRs}
					onToggleDrafts={onToggleDrafts}
					onToggleBotPRs={onToggleBotPRs}
					sortOption={sortOption}
					onSetSortOption={onSetSortOption}
					showPendingWithProjectRules={showPendingWithProjectRules}
					onTogglePendingWithProjectRules={onTogglePendingWithProjectRules}
					showPendingWithAllApprovals={showPendingWithAllApprovals}
					onTogglePendingWithAllApprovals={onTogglePendingWithAllApprovals}
					greyOutBlockingComments={greyOutBlockingComments}
					onToggleGreyOutBlockingComments={onToggleGreyOutBlockingComments}
					enableCommentsExpansion={enableCommentsExpansion}
					onToggleCommentsExpansion={onToggleCommentsExpansion}
					viewMode={viewMode}
					onSetViewMode={onSetViewMode}
					showSwimlaneMergedColumn={showSwimlaneMergedColumn}
					onToggleShowSwimlaneMergedColumn={onToggleShowSwimlaneMergedColumn}
					showSwimlaneDeletedColumn={showSwimlaneDeletedColumn}
					onToggleShowSwimlaneDeletedColumn={onToggleShowSwimlaneDeletedColumn}
					useLocalTime={useLocalTime}
					onToggleUseLocalTime={onToggleUseLocalTime}
					watchProjects={watchProjects}
					setWatchProjects={setWatchProjects}
					excludeProjects={excludeProjects}
					setExcludeProjects={setExcludeProjects}
					swimlaneHideCreatedDaysThreshold={swimlaneHideCreatedDaysThreshold}
					setSwimlaneHideCreatedDaysThreshold={
						setSwimlaneHideCreatedDaysThreshold
					}
					swimlaneHideUpdatedDaysThreshold={swimlaneHideUpdatedDaysThreshold}
					setSwimlaneHideUpdatedDaysThreshold={
						setSwimlaneHideUpdatedDaysThreshold
					}
				/>
			)}
		</>
	);
};
